import { Control, Controller, Path } from 'react-hook-form';
import type { FormControlLabelProps } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { FieldValues } from 'react-hook-form/dist/types/fields';

type IProps = Omit<FormControlLabelProps, 'control'>;

export type SwitchElementProps<T> = IProps & {
  name: Path<T>;
  control?: Control<T>;
};

/**
 * Componente SwitchElement
 *
 * Interruptor (switch) integrado con react-hook-form.
 *
 * @component
 * @param {object} props - Props del componente.
 * @param {string} props.name - Nombre del campo en el formulario.
 * @param {Control} [props.control] - Control de react-hook-form.
 * @example
 * <SwitchElement name="activo" control={control} label="Activo" />
 */
export function SwitchElement<TFieldValues extends FieldValues>({
  name,
  control,
  ...other
}: SwitchElementProps<TFieldValues>) {
  return (
    <FormControlLabel
      control={
        <Controller
          control={control}
          name={name}
          render={({ field: { onBlur, name: fieldName, ref, value, onChange } }) => (
            <Switch
              checked={Boolean(value)}
              inputRef={ref}
              name={fieldName}
              onBlur={onBlur}
              onChange={(event, checked) => {
                const next =
                  typeof checked === 'boolean'
                    ? checked
                    : (event.target as HTMLInputElement).checked;
                onChange(next);
              }}
            />
          )}
        />
      }
      {...other}
    />
  );
}

export default SwitchElement;
